import React from 'react';
import styled, { css } from 'styled-components';
import { margin, padding } from '../../styles/mixins';
export function withSpacing(ComposedComponent, defaults) {
  const componentName = (ComposedComponent == null ? void 0 : ComposedComponent.displayName) || (ComposedComponent == null ? void 0 : ComposedComponent.name) || 'Component';
  const Spacing = styled(ComposedComponent).withConfig({
    displayName: "withSpacing__Spacing",
    componentId: "hknguh-0"
  })(["", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";"], x => x.m && margin(x.m), x => x.mx && x.mx !== 'auto' && margin(x.mx, 'x'), x => x.my && margin(x.my, 'y'), x => x.mt && margin(x.mt, 't'), x => x.mr && x.mr !== 'auto' && margin(x.mr, 'r'), x => x.mb && margin(x.mb, 'b'), x => x.ml && x.ml !== 'auto' && margin(x.ml, 'l'), x => x.p && padding(x.p), x => x.px && padding(x.px, 'x'), x => x.py && padding(x.py, 'y'), x => x.pt && padding(x.pt, 't'), x => x.pr && padding(x.pr, 'r'), x => x.pb && padding(x.pb, 'b'), x => x.pl && padding(x.pl, 'l'), x => x.mx === 'auto' && css(["margin-right:auto;margin-left:auto;"]), x => x.mr === 'auto' && css(["margin-right:auto;"]), x => x.ml === 'auto' && css(["margin-left:auto;"]));
  Spacing.displayName = componentName;

  const ComposedComponentWithSpacing = props => {
    const {
      m,
      mx,
      my,
      mt,
      mr,
      mb,
      ml,
      p,
      px,
      py,
      pt,
      pr,
      pb,
      pl
    } = props;

    if (m || mx || my || mt || mr || mb || ml || p || px || py || pt || pr || pb || pl) {
      return /*#__PURE__*/React.createElement(Spacing, props);
    } else {
      return /*#__PURE__*/React.createElement(ComposedComponent, props);
    }
  };

  ComposedComponentWithSpacing.displayName = `${componentName}_withSpacing`;
  ComposedComponentWithSpacing.defaultProps = defaults || {};
  return ComposedComponentWithSpacing;
}
export default withSpacing;